import React, { useEffect, Component, useState } from 'react';
import { NavLink, Link } from "react-router-dom";
import { Table, Modal } from 'react-bootstrap';
import StarRatings from 'react-star-ratings';
import { Sidebar } from '../sidebar/Sidebar';
import Navbar from '../navbar/navbar';
import { UserData } from "../demoData/userData";
import profile from "../images/profile.jpg";
import UpdateBusinessForm from '../UpdateBusinessForm/UpdateBusinessForm';
import UpdateUserForm from '../updateUserForm/updateUserForm';
import { deleteUser, getAllUsers } from '../../../Services/users.service';
import ConfirmationModal from '../../shared/confirmationModal/confirmationModal'
import _ from 'lodash';

export const AdminUsers = () => {
  const [data, setData] = useState([]);
  const [updateData, setUpdateData] = useState({
    userName: '',
    email: '',
    status: "",
  })

  const [showEditForm, setShowEditForm] = useState(false);
  const [editItem, setEditItem] = useState(null)
  const [isConfirm, setIsConfirm] = useState(false)
  const [filteredList, setFilteredList] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const handleCloseEdit = () => {
    getUsers()
    setShowEditForm(false);
  }
  const handleShowEdit = (id, item) => {
    setEditItem(item)
    setShowEditForm(true);
  }


  function handleChange(e) {
    setUpdateData({ ...updateData, [e.target.name]: e.target.value })
    console.log("setValue");
    console.log(e.target.name);
    console.log(e.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log(updateData);
  }

  const redColor = {
    color: 'red'
  }
  const greenColor = {
    color: '#28CB89'
  }

  useEffect(() => {
    getUsers()
  }, [])

  let getUsers = () => {
    getAllUsers().then(u => {
      console.log(u);
      setData(u)
    })
  }


  const removeHandle = (id, index) => {
    if (!!id) {
      deleteUser(id).then(resp => {
        console.log('delete resp', resp);
        const removeArr = [...data].filter(todo => todo.userId !== id) //all id matches except which we want to remove
        data.splice(index, 1)
        setData(removeArr) //remove from state
        setIsConfirm(false)
        localStorage.removeItem('uId')
        localStorage.removeItem('indexId')
      })
    }

  }

  // const removeHandle = (id, index) => {
  //   const removeArr = [...UserData].filter(todo => todo.id !== id);//all id matches except which we want to remove
  //   UserData.splice(index, 1);
  //   setData(removeArr); //remove from state  
  //   console.log(removeArr);

  // }

  let toggleModal = (userId, index) => {
    localStorage.uId = userId
    localStorage.indexId = index
    setIsConfirm(true)
  }

  let handleSearchValue = (value) => {
    console.log(value);
    let search = value;
    search = search.trim();
    search = search.toLowerCase();

    if (!!search) {
      setSearchValue(search)
      let localList = [];
      _.forEach(data, (value) => {

        if (_.includes((value.name).toLowerCase(), search) || _.includes((value.email).toLowerCase(), search)) {
          localList.push(value);
        }

      });
      setFilteredList(localList)
    }
    else {
      setSearchValue(search)
      let localList = [];
      setFilteredList(localList)
    }
  }

  return (
    <>

      {/* Page Wrapper */}
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* End of Sidebar */}
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/* Main Content */}
          <div id="content">
            <Navbar setValue={handleSearchValue} />

            {/* Begin Page Content */}
            <div className="container-fluid">

              {/* Content Row */}
              <div className="row">
                <div className="col">
                  <h2 className="theme-color">Users Information</h2>
                </div>
              </div>
              <div className="row">

                <div className="col-12">
                  <Table responsive striped bordered hover className="bg-white dashboardTable">
                    <thead>

                      <tr>
                        <th>User Name</th>
                        <th>Email</th>
                        <th>Register Date</th>
                        <th>Status</th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {!!searchValue ?
                        filteredList.length > 0 ?
                          filteredList.map((item, index) =>
                            <tr key={index}>
                              <td>{item.name} </td>
                              <td>{item.email}</td>
                              <td><p className="mb-0 w-mc">{item.registeredDate} </p></td>
                              <td className="">{item.status ? 'Active' : 'Deactive'}</td>
                              <td>
                                {
                                  <button className="btn btn-success w-100 fs-14" onClick={() => handleShowEdit(item.userId, item)}>Edit</button>
                                }
                              </td>
                              <td>
                                {item.name != "admin" || item.role != "admin" ?
                                  <button className="btn btn-danger w-100 fs-14" onClick={() => toggleModal(item.userId, index)}>Delete</button>
                                  :
                                  null
                                }
                              </td>
                              <td>
                                <NavLink to={{
                                  pathname: "/admin/reveiw-detail",
                                  userId: item.userId
                                }} className="btn btn-primary w-100 fs-14" >Reviews</NavLink>
                              </td>
                            </tr>
                          )
                          :
                          <tr>
                            <td className="fs-14 text-center" colSpan={7}>Nothing found...</td>
                          </tr>
                        :
                        data.map((item, index) =>
                          <tr key={index}>
                            <td>  {item.name} </td>
                            <td> {item.email}</td>
                            <td><p className="mb-0 w-mc">{item.registeredDate} </p></td>
                            <td className="">{item.status ? 'Active' : 'Deactive'}</td>
                            <td>
                              <button className="btn btn-success w-100 fs-14" onClick={() => handleShowEdit(item.userId, item)}>Edit</button>
                            </td>
                            <td>
                              {item.name != "admin" || item.role != "admin" ?
                                <button className="btn btn-danger w-100 fs-14" onClick={() => toggleModal(item.userId, index)}>Delete</button>
                                :
                                null
                              }
                            </td>
                            <td>
                              <NavLink to={{
                                pathname: "/admin/reveiw-detail",
                                userId: item.userId
                              }} className="btn btn-primary w-100 fs-14" >Reviews</NavLink>
                            </td>
                          </tr>
                        )}

                    </tbody>
                  </Table>
                </div>
              </div>

            </div>
            {/* /.container-fluid */}

          </div>
          {/* End of Main Content */}
        </div>
        {/* End of Content Wrapper */}
      </div>
      {/* End of Page Wrapper */}

      {/* Scroll to Top Button*/}
      <a className="scroll-to-top rounded" href="#">
        <i className="fas fa-angle-up" />
      </a>
      {/* Edit business modal */}
      <Modal show={showEditForm} onHide={handleCloseEdit} className="addBusinessModal">
        <Modal.Header >
          <div className=" headerColor  text-center col-12">
            <h3 className="bold-font h4 mb-0 themeColor2 text-center"><i className="fa fa-envelope" /> Edit User</h3>
          </div>
          <span className="close" onClick={handleCloseEdit}><i class="fa fa-times" aria-hidden="true"></i></span>
        </Modal.Header>
        {/* <UpdateBusinessForm val={updateData} /> */}
        <UpdateUserForm setHandleClose={handleCloseEdit} userData={editItem} />

      </Modal>

      {isConfirm ?
        <ConfirmationModal isShowModal={isConfirm}
          callback={(type) => {
            console.log('callback type', type);
            if (type == 'delete') {
              removeHandle(localStorage.uId, localStorage.indexId)
            }
            else if (type == 'hide') {
              setIsConfirm(false)
            }
          }}
        />
        :
        null
      }

    </>
  )
}

